'use client';

import { COLORS } from '@/constants';
import styled from 'styled-components';

export const ParamRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid ${COLORS['neutral/100']};

  &:last-child {
    border-bottom: none;
  }
`;

export const ParamLabelGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const ParamLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${COLORS['primary/900']};
`;

export const ParamDesc = styled.span`
  font-size: 13px;
  color: ${COLORS['neutral/400']};
  line-height: 1.4;
  max-width: 480px;
`;

export const ParamControl = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;
